module.exports = __webpack_public_path__ + "static/media/not-found.06397502.svg";